import Component, { publish } from '../../js/lib/component';
import $ from 'jquery';
import Vue from 'vue/dist/vue.common';
import store from '../../js/Store';

const classList = {
  root: '.js-cart-header'
};

class CartHeader extends Component {
  init() {
    new Vue({
      name: 'CartHeader',
      el: this.$.root.get(0),
      store,
      computed: {
        cost() {
          return store.getters.cost;
        },
        amount() {
          return store.getters.amount;
        }
      }
    });
  }
  events() {
    this.$.document.on('click', e => {
      const $target = $(e.target);

      if (
        $target.is(classList.root) ||
        $target.closest(classList.root).length
      ) {
        e.preventDefault();
        publish('minicart:open');
      }
    });
  }
}

export default Component.mount(CartHeader, {
  name: 'CartHeader',
  classList
});
